// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/copilot_cel/v1/private/copilot_cel.proto" (package "c1.api.copilot_cel.v1.private", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { EditorValidationEnv } from "../../../editor/v1/editor";
/**
 * @generated from protobuf message c1.api.copilot_cel.v1.private.GetHelperServiceRequest
 */
export interface GetHelperServiceRequest {
    /**
     * Deprecated: use validation_env instead.
     *
     * @deprecated
     * @generated from protobuf field: c1.api.copilot_cel.v1.private.Env env = 1 [deprecated = true]
     */
    env: Env;
    /**
     * @generated from protobuf field: string prompt = 2
     */
    prompt: string;
    /**
     * @generated from protobuf field: string expression = 3
     */
    expression: string;
    /**
     * The validation environment for the CEL expression.
     *
     * @generated from protobuf field: c1.api.editor.v1.EditorValidationEnv validation_env = 4
     */
    validationEnv: EditorValidationEnv;
}
/**
 * @generated from protobuf message c1.api.copilot_cel.v1.private.GetHelperServiceResponse
 */
export interface GetHelperServiceResponse {
    /**
     * @generated from protobuf field: string expression = 1
     */
    expression: string;
    /**
     * @generated from protobuf field: string explanation = 2
     */
    explanation: string;
}
/**
 * Env identifies the CEL environment type.
 * Deprecated: Use c1.api.editor.v1.EditorValidationEnv instead.
 *
 * @deprecated
 * @generated from protobuf enum c1.api.copilot_cel.v1.private.Env
 */
export enum Env {
    /**
     * @generated from protobuf enum value: ENV_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Policy rule conditionals - evaluates to bool, determines which step applies
     *
     * @generated from protobuf enum value: ENV_POLICY_CONDITIONAL = 1;
     */
    POLICY_CONDITIONAL = 1,
    /**
     * Dynamic group membership - evaluates to bool
     *
     * @generated from protobuf enum value: ENV_DYNAMIC_GROUP_MEMBERSHIP = 2;
     */
    DYNAMIC_GROUP_MEMBERSHIP = 2,
    /**
     * Policy step approvers - evaluates to User or list<User>
     *
     * @generated from protobuf enum value: ENV_POLICY_STEP = 3;
     */
    POLICY_STEP = 3,
    /**
     * Workflow trigger conditions - uses xcel.TriggersEnv (ctx.trigger.*)
     *
     * @generated from protobuf enum value: ENV_WORKFLOW_TRIGGER = 4;
     */
    WORKFLOW_TRIGGER = 4,
    /**
     * Workflow step expressions - uses xcel.WorkflowExecutionEnv (ctx.trigger.*, ctx.steps.*, directory funcs)
     *
     * @generated from protobuf enum value: ENV_WORKFLOW_STEP = 5;
     */
    WORKFLOW_STEP = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class GetHelperServiceRequest$Type extends MessageType<GetHelperServiceRequest> {
    constructor() {
        super("c1.api.copilot_cel.v1.private.GetHelperServiceRequest", [
            { no: 1, name: "env", kind: "enum", T: () => ["c1.api.copilot_cel.v1.private.Env", Env, "ENV_"] },
            { no: 2, name: "prompt", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 3, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "0", maxLen: "2048" } } } },
            { no: 4, name: "validation_env", kind: "enum", T: () => ["c1.api.editor.v1.EditorValidationEnv", EditorValidationEnv, "EDITOR_VALIDATION_ENV_"] }
        ]);
    }
    create(value?: PartialMessage<GetHelperServiceRequest>): GetHelperServiceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.env = 0;
        message.prompt = "";
        message.expression = "";
        message.validationEnv = 0;
        if (value !== undefined)
            reflectionMergePartial<GetHelperServiceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetHelperServiceRequest): GetHelperServiceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.copilot_cel.v1.private.Env env = 1 [deprecated = true] */ 1:
                    message.env = reader.int32();
                    break;
                case /* string prompt */ 2:
                    message.prompt = reader.string();
                    break;
                case /* string expression */ 3:
                    message.expression = reader.string();
                    break;
                case /* c1.api.editor.v1.EditorValidationEnv validation_env */ 4:
                    message.validationEnv = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetHelperServiceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.copilot_cel.v1.private.Env env = 1 [deprecated = true]; */
        if (message.env !== 0)
            writer.tag(1, WireType.Varint).int32(message.env);
        /* string prompt = 2; */
        if (message.prompt !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.prompt);
        /* string expression = 3; */
        if (message.expression !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.expression);
        /* c1.api.editor.v1.EditorValidationEnv validation_env = 4; */
        if (message.validationEnv !== 0)
            writer.tag(4, WireType.Varint).int32(message.validationEnv);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.copilot_cel.v1.private.GetHelperServiceRequest
 */
export const GetHelperServiceRequest = new GetHelperServiceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetHelperServiceResponse$Type extends MessageType<GetHelperServiceResponse> {
    constructor() {
        super("c1.api.copilot_cel.v1.private.GetHelperServiceResponse", [
            { no: 1, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "explanation", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetHelperServiceResponse>): GetHelperServiceResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expression = "";
        message.explanation = "";
        if (value !== undefined)
            reflectionMergePartial<GetHelperServiceResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetHelperServiceResponse): GetHelperServiceResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string expression */ 1:
                    message.expression = reader.string();
                    break;
                case /* string explanation */ 2:
                    message.explanation = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetHelperServiceResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string expression = 1; */
        if (message.expression !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.expression);
        /* string explanation = 2; */
        if (message.explanation !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.explanation);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.copilot_cel.v1.private.GetHelperServiceResponse
 */
export const GetHelperServiceResponse = new GetHelperServiceResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.copilot_cel.v1.private.HelperService
 */
export const HelperService = new ServiceType("c1.api.copilot_cel.v1.private.HelperService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: GetHelperServiceRequest, O: GetHelperServiceResponse }
]);
